import type { Location } from '../locations/locations.types'
import type { StoreShowResponse } from './stores.types'

export const DESIGNERS_CHOICE_ONLY_EMPTY_COPY =
  "Add or mark a Designer's Choice product first to schedule Designer's Choice-only availability."

export const AVAILABILITY_CHANGES_ADMIN_COPY =
  "Plan closures, Designer's Choice-only periods, pickup and delivery limits, and temporary hours from Availability."

export const PAUSED_ORDERING_ADMIN_COPY =
  "Customers can browse your storefront, but they can't add items to their cart or begin checkout. Customers who have already started checkout can still complete their order."

type SameDayDeliveryPromotionLocation = Pick<
  Location,
  'is_active' | 'is_delivery' | 'is_delivery_cutoff_overrides_enabled'
>

export function hasAvailableDesignersChoiceProducts(store: StoreShowResponse | undefined): boolean {
  // The store endpoint sends an empty array when the organization has no store yet.
  if (!store || Array.isArray(store)) {
    return false
  }

  return (store.designers_choice_collection?.storefront_products_count ?? 0) > 0
}

export function isSameDayDeliveryPromotionEligible(
  locations: SameDayDeliveryPromotionLocation[] = []
): boolean {
  const activeDeliveryLocations = locations.filter(
    (location) => location?.is_active && location?.is_delivery
  )

  return (
    activeDeliveryLocations.length === 1 &&
    !activeDeliveryLocations[0]?.is_delivery_cutoff_overrides_enabled
  )
}
